import api from '@services/interceptor';
import { useWorkspaceStore } from '@stores/WorkspaceData';
class TarService {
  constructor(){
    this.wp = undefined
  }
  async Get(allowCreate = true){
    if(!this.wp)this.wp = await useWorkspaceStore()
    try {
      const response = await api.get(`/api/obs/${this.wp.wpid}`);
      if ((!response.data || !response.data.length) && allowCreate){
        // Заявок ещё нет — создаём одну по умолчанию, повторно не пытаемся
        await this.Create()
        return await this.Get(false)
      }
      return response.data;
    } catch (error) {
      console.log(error)
    }
    return null
  }
  async Put(data){
    try {
      const response = await api.put(`/api/obs/${this.wp.wpid}/${data.id}`, data);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }
  async Create(){
    if(!this.wp)this.wp = useWorkspaceStore()
    try {
      const tar = {
        "name": "Новая заявка",
        "satelliteId": this.wp.sat[0]?.id ?? 0,
        "latitude": 0,
        "longitude": 0,
        "shootingMode": "PHOTO_NON_AGILE",
        "duration": 0
      }
      const response = await api.post(`/api/obs/${this.wp.wpid}`, tar);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }

}

export const tarService = new TarService();